const PaymentTypes = {
  GET_PAYMENT_LIST_REQUEST: 'GET_PAYMENT_LIST_REQUEST',
  GET_PAYMENT_LIST_SUCCESS: 'GET_PAYMENT_LIST_SUCCESS',
  GET_PAYMENT_LIST_ERROR: 'GET_PAYMENT_LIST_ERROR',

  ADD_PAYMENT_REQUEST: 'ADD_PAYMENT_REQUEST',
  ADD_PAYMENT_SUCCESS: 'ADD_PAYMENT_SUCCESS',
  ADD_PAYMENT_ERROR: 'ADD_PAYMENT_ERROR',

  GET_PAYMENT_ITEM_REQUEST: 'GET_PAYMENT_ITEM_REQUEST',
  GET_PAYMENT_ITEM_SUCCESS: 'GET_PAYMENT_ITEM_SUCCESS',
  GET_PAYMENT_ITEM_ERROR: 'GET_PAYMENT_ITEM_ERROR',

  UPDATE_PAYMENT_REQUEST: 'UPDATE_PAYMENT_REQUEST',
  UPDATE_PAYMENT_SUCCESS: 'UPDATE_PAYMENT_SUCCESS',
  UPDATE_PAYMENT_ERROR: 'UPDATE_PAYMENT_ERROR',

  DELETE_PAYMENT_REQUEST: 'DELETE_PAYMENT_REQUEST',
  DELETE_PAYMENT_SUCCESS: 'DELETE_PAYMENT_SUCCESS',
  DELETE_PAYMENT_ERROR: 'DELETE_PAYMENT_ERROR',

  GET_INVOICE_NUMBER_REQUEST: 'GET_INVOICE_NUMBER_REQUEST',
  GET_INVOICE_NUMBER_SUCCESS: 'GET_INVOICE_NUMBER_SUCCESS',
  GET_INVOICE_NUMBER_ERROR: 'GET_INVOICE_NUMBER_ERROR',

  GET_PAYMENT_METHOD_REQUEST: 'GET_PAYMENT_METHOD_REQUEST',
  GET_PAYMENT_METHOD_SUCCESS: 'GET_PAYMENT_METHOD_SUCCESS',
  GET_PAYMENT_METHOD_ERROR: 'GET_PAYMENT_METHOD_ERROR',

  GET_PAYMENT_REQUEST_TYPE_REQUEST: 'GET_PAYMENT_REQUEST_TYPE_REQUEST',
  GET_PAYMENT_REQUEST_TYPE_SUCCESS: 'GET_PAYMENT_REQUEST_TYPE_SUCCESS',
  GET_PAYMENT_REQUEST_TYPE_ERROR: 'GET_PAYMENT_REQUEST_TYPE_ERROR',

  UPDATE_PREVIEW_PAYMENT_REQUEST: 'UPDATE_PREVIEW_PAYMENT_REQUEST',
  UPDATE_PREVIEW_PAYMENT_SUCCESS: 'UPDATE_PREVIEW_PAYMENT_SUCCESS',
  UPDATE_PREVIEW_PAYMENT_ERROR: 'UPDATE_PREVIEW_PAYMENT_ERROR',

  GET_PAYMENT_RESEND_REQUEST: 'GET_PAYMENT_RESEND_REQUEST',
  GET_PAYMENT_RESEND_SUCCESS: 'GET_PAYMENT_RESEND_SUCCESS',
  GET_PAYMENT_RESEND_ERROR: 'GET_PAYMENT_RESEND_ERROR',

  GET_PAYMENT_REMINDER_REQUEST: 'GET_PAYMENT_REMINDER_REQUEST',
  GET_PAYMENT_REMINDER_SUCCESS: 'GET_PAYMENT_REMINDER_SUCCESS',
  GET_PAYMENT_REMINDER_ERROR: 'GET_PAYMENT_REMINDER_ERROR',

  GET_PAYMENT_COPY_REQUEST: 'GET_PAYMENT_COPY_REQUEST',
  GET_PAYMENT_COPY_SUCCESS: 'GET_PAYMENT_COPY_SUCCESS',
  GET_PAYMENT_COPY_ERROR: 'GET_PAYMENT_COPY_ERROR',

  GET_ALL_TRANSACTION_REQUEST: 'GET_ALL_TRANSACTION_REQUEST',
  GET_ALL_TRANSACTION_SUCCESS: 'GET_ALL_TRANSACTION_SUCCESS',
  GET_ALL_TRANSACTION_ERROR: 'GET_ALL_TRANSACTION_ERROR',

  GET_TRANSACTION_ITEM_REQUEST: 'GET_TRANSACTION_ITEM_REQUEST',
  GET_TRANSACTION_ITEM_SUCCESS: 'GET_TRANSACTION_ITEM_SUCCESS',
  GET_TRANSACTION_ITEM_ERROR: 'GET_TRANSACTION_ITEM_ERROR',

  GET_TRANSACTION_STATUS_REQUEST: 'GET_TRANSACTION_STATUS_REQUEST',
  GET_TRANSACTION_STATUS_SUCCESS: 'GET_TRANSACTION_STATUS_SUCCESS',
  GET_TRANSACTION_STATUS_ERROR: 'GET_TRANSACTION_STATUS_ERROR',

  PREVIEW_MAIL_REQUEST: 'PREVIEW_MAIL_REQUEST',
  PREVIEW_MAIL_SUCCESS: 'PREVIEW_MAIL_SUCCESS',
  PREVIEW_MAIL_ERROR: 'PREVIEW_MAIL_ERROR',

  GET_PAYMENT_DETAILS_REQUEST: 'GET_PAYMENT_DETAILS_REQUEST',
  GET_PAYMENT_DETAILS_SUCCESS: 'GET_PAYMENT_DETAILS_SUCCESS',
  GET_PAYMENT_DETAILS_ERROR: 'GET_PAYMENT_DETAILS_ERROR',

  GET_GENERATE_PAYPAL_REQUEST: 'GET_GENERATE_PAYPAL_REQUEST',
  GET_GENERATE_PAYPAL_SUCCESS: 'GET_GENERATE_PAYPAL_SUCCESS',
  GET_GENERATE_PAYPAL_ERROR: 'GET_GENERATE_PAYPAL_ERROR',

  UPDATE_AUTHORIZENET_CARD_REQUEST: 'UPDATE_AUTHORIZENET_CARD_REQUEST',
  UPDATE_AUTHORIZENET_CARD_SUCCESS: 'UPDATE_AUTHORIZENET_CARD_SUCCESS',
  UPDATE_AUTHORIZENET_CARD_ERROR: 'UPDATE_AUTHORIZENET_CARD_ERROR',

  UPDATE_STRIPE_CREATE_REQUEST: 'UPDATE_STRIPE_CREATE_REQUEST',
  UPDATE_STRIPE_CREATE_SUCCESS: 'UPDATE_STRIPE_CREATE_SUCCESS',
  UPDATE_STRIPE_CREATE_ERROR: 'UPDATE_STRIPE_CREATE_ERROR',

  UPDATE_STRIPE_CAPTURE_REQUEST: 'UPDATE_STRIPE_CAPTURE_REQUEST',
  UPDATE_STRIPE_CAPTURE_SUCCESS: 'UPDATE_STRIPE_CAPTURE_SUCCESS',
  UPDATE_STRIPE_CAPTURE_ERROR: 'UPDATE_STRIPE_CAPTURE_ERROR',

  GET_PAYPAL_SUCCESS_REQUEST: 'GET_PAYPAL_SUCCESS_REQUEST',
  GET_PAYPAL_SUCCESS_SUCCESS: 'GET_PAYPAL_SUCCESS_SUCCESS',
  GET_PAYPAL_SUCCESS_ERROR: 'GET_PAYPAL_SUCCESS_ERROR',

  GET_PAYPAL_CANCEL_REQUEST: 'GET_PAYPAL_CANCEL_REQUEST',
  GET_PAYPAL_CANCEL_SUCCESS: 'GET_PAYPAL_CANCEL_SUCCESS',
  GET_PAYPAL_CANCEL_ERROR: 'GET_PAYPAL_CANCEL_ERROR',

  GET_PAYMENT_PENDING_ITEM_REQUEST: 'GET_PAYMENT_PENDING_ITEM_REQUEST',
  GET_PAYMENT_PENDING_ITEM_SUCCESS: 'GET_PAYMENT_PENDING_ITEM_SUCCESS',
  GET_PAYMENT_PENDING_ITEM_ERROR: 'GET_PAYMENT_PENDING_ITEM_ERROR',

  GET_MANUAL_PAYMENT_LIST_REQUEST: 'GET_MANUAL_PAYMENT_LIST_REQUEST',
  GET_MANUAL_PAYMENT_LIST_SUCCESS: 'GET_MANUAL_PAYMENT_LIST_SUCCESS',
  GET_MANUAL_PAYMENT_LIST_ERROR: 'GET_MANUAL_PAYMENT_LIST_ERROR',

  ADD_MANUAL_PAYMENT_REQUEST: 'ADD_MANUAL_PAYMENT_REQUEST',
  ADD_MANUAL_PAYMENT_SUCCESS: 'ADD_MANUAL_PAYMENT_SUCCESS',
  ADD_MANUAL_PAYMENT_ERROR: 'ADD_MANUAL_PAYMENT_ERROR',

  GET_MANUAL_PAYMENT_ITEM_REQUEST: 'GET_MANUAL_PAYMENT_ITEM_REQUEST',
  GET_MANUAL_PAYMENT_ITEM_SUCCESS: 'GET_MANUAL_PAYMENT_ITEM_SUCCESS',
  GET_MANUAL_PAYMENT_ITEM_ERROR: 'GET_MANUAL_PAYMENT_ITEM_ERROR',

  UPDATE_MANUAL_PAYMENT_REQUEST: 'UPDATE_MANUAL_PAYMENT_REQUEST',
  UPDATE_MANUAL_PAYMENT_SUCCESS: 'UPDATE_MANUAL_PAYMENT_SUCCESS',
  UPDATE_MANUAL_PAYMENT_ERROR: 'UPDATE_MANUAL_PAYMENT_ERROR',

  GET_MANUAL_PAYMENT_FILTER_REQUEST: 'GET_MANUAL_PAYMENT_FILTER_REQUEST',
  GET_MANUAL_PAYMENT_FILTER_SUCCESS: 'GET_MANUAL_PAYMENT_FILTER_SUCCESS',
  GET_MANUAL_PAYMENT_FILTER_ERROR: 'GET_MANUAL_PAYMENT_FILTER_ERROR',

  UPDATE_MANUAL_QUERY_PARAMS: 'UPDATE_MANUAL_QUERY_PARAMS',

  DELETE_TIMESHEET_REQUEST: 'DELETE_TIMESHEET_REQUEST',
  DELETE_TIMESHEET_SUCCESS: 'DELETE_TIMESHEET_SUCCESS',
  DELETE_TIMESHEET_ERROR: 'DELETE_TIMESHEET_ERROR',

  GET_INVOICE_FILTER_REQUEST: 'GET_INVOICE_FILTER_REQUEST',
  GET_INVOICE_FILTER_SUCCESS: 'GET_INVOICE_FILTER_SUCCESS',
  GET_INVOICE_FILTER_ERROR: 'GET_INVOICE_FILTER_ERROR',

  GET_GENERATE_VEEM_REQUEST: 'GET_GENERATE_VEEM_REQUEST',
  GET_GENERATE_VEEM_SUCCESS: 'GET_GENERATE_VEEM_SUCCESS',
  GET_GENERATE_VEEM_ERROR: 'GET_GENERATE_VEEM_ERROR',

  UPDATE_CLOVER_CHARGE_REQUEST: 'UPDATE_CLOVER_CHARGE_REQUEST',
  UPDATE_CLOVER_CHARGE_SUCCESS: 'UPDATE_CLOVER_CHARGE_SUCCESS',
  UPDATE_CLOVER_CHARGE_ERROR: 'UPDATE_CLOVER_CHARGE_ERROR',

  GET_PAYMENT_STATUS_REQUEST: 'GET_PAYMENT_STATUS_REQUEST',
  GET_PAYMENT_STATUS_SUCCESS: 'GET_PAYMENT_STATUS_SUCCESS',
  GET_PAYMENT_STATUS_ERROR: 'GET_PAYMENT_STATUS_ERROR',

  GET_SCHEDULE_CANCEL_REQUEST: 'GET_SCHEDULE_CANCEL_REQUEST',
  GET_SCHEDULE_CANCEL_SUCCESS: 'GET_SCHEDULE_CANCEL_SUCCESS',
  GET_SCHEDULE_CANCEL_ERROR: 'GET_SCHEDULE_CANCEL_ERROR'
};

export default PaymentTypes;
